import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

const SummaryCard = styled('section')`
  ${mediaQuery('', 'tablet')} {
    -webkit-flex-basis: calc(50% - 8px);
    -ms-flex-preferred-size: calc(50% - 8px);
    flex-basis: calc(50% - 8px);
  }

  color: var(--CINight);
  .question-description {
    width: 83%;
    .question-name {
      font-size: 14px;
      font-weight: 500;
      margin-top: 5px;
      line-height: 19px;
    }

    .question-summary {
      font-size: 12px;
      font-weight: 400;
      height: 2rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .mdi.mdi-chevron-right {
    font-size: 22px;
    margin-top: -2px;
  }

  .mdi.mdi-check-circle-outline {
    font-size: 20px;

    &::before {
      line-height: 20px;
    }
    color: #d1d6d7;
    margin-right: 10px;
    &.complete {
      color: #16a550;
    }
  }
`

export { SummaryCard }
